import { FormPreview as SharedFormPreview, type FormRendererComponents } from "@froppio/form-renderer";
import type { BuilderDraft } from "@froppio/form-core";
import { Button } from "@/shared/components/shadcn/Button";
import { Input } from "@/shared/components/shadcn/Input";
import { Select } from "@/shared/components/shadcn/Select";
import { TextArea } from "@/shared/components/shadcn/TextArea";
import { FormField } from "@/shared/components/ui/FormField";
import { Section } from "@/shared/components/ui/Section";

const components = { Button, Input, Select, TextArea, FormField, Section } satisfies FormRendererComponents;

export function FormPreview({ draft }: { draft: BuilderDraft }) {
  return <SharedFormPreview draft={draft} components={components} showAnswerActions={false} />;
}
